import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { validarRFC, erroresValidarIdentificacion, reglasValidacionRecpetor } from "app/logic/cliente";

type Entity = models.ReceptorFactura;

export interface Props {
    value: Entity;
    readonly?: boolean;
    editTipoPersona?: boolean;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

export function validarReceptor(x: models.ReceptorFactura) {
    const rules: validation.Rules<models.ReceptorFactura> = {
        Rfc: validation.required,
        Nombre: validation.required
    };
    const rules2 = reglasValidacionRecpetor;
    const allRules = kea.validation.andRules(rules, rules2);
    return validation.getErrors(allRules, x);
}

/**
* Componente para editar un models.ReceptorFactura
*/
class ReceptorFacturaNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validarReceptor(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value, readonly, editTipoPersona } = this.props;
        const Text = this.getField(kea.Text);
        const TipoPersona = this.getField(selectores.TipoPersona);
        const RegimenFiscal = this.getField(selectores.ClaveRegimenFiscalSat);
        return (
            <div >
                {kea.autogrid(4, [
                    <TipoPersona field="TipoPersona" label="Tipo de persona" readonly={readonly || editTipoPersona} />,
                    <Text field="Rfc" label="RFC:" readonly={readonly} />,
                    <Text field="Nombre" label="Nombre:" readonly={readonly} />,
                    <Text field="NumeroRegistroIdentidadFiscal" label="No. registro identidad fiscal" readonly={readonly} />,

                    <RegimenFiscal field="RegimenFiscal" label="Regimen fiscal" readonly={readonly} />,
                ])}
            </div>
        );
    }
}

export const ReceptorFactura = componentToRx(ReceptorFacturaNoRx);



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/componentes/receptorfactura.tsx